// Sourced stats for the /for-recruiters landing — verified against primary sources.
//
// Each stat exposes the visible number, label, and a citation URL that opens
// in a new tab via the [n] superscript link in the stats bar.
//
// NOTE on #2 (BLS hourly wage): bls.gov blocks automated fetching. The figure
// ($72,910/yr median, May 2024 = $35.05/hr) was verified via BLS search snippets,
// not an in-tool page load — spot-check the URL in a browser if you cite a newer release.

export const STATS = [
  {
    id: 1,
    number: '$5,475',
    label: 'Average cost to fill one role',
    sourceUrl: 'https://www.shrm.org/about/press-room/shrm-releases-2025-benchmarking-reports--how-does-your-organizat',
    sourceLabel: 'SHRM, 2025',
    verified: true,
  },
  {
    id: 2,
    number: '$35/hr',
    label: 'Median U.S. recruiter pay per hour',
    sourceUrl: 'https://www.bls.gov/ooh/business-and-financial/human-resources-specialists.htm',
    sourceLabel: 'U.S. BLS, 2024',
    verified: true,
  },
  {
    id: 3,
    number: '~1 day/wk',
    label: 'Recruiter time AI saves on screening tasks',
    sourceUrl: 'https://business.linkedin.com/talent-solutions/resources/future-of-recruiting',
    sourceLabel: 'LinkedIn, 2025',
    verified: true,
  },
];
